<template>
  <!-- 商品简介 -->
  <div class="brief">
    <!-- 商品价格 -->
    <div class="sales">
      <div class="price">
        <span v-if="!isSymbolBehindPrice" :style="{'letter-spacing': detailData.symbol === '฿' ? '3px' : ''}">{{detailData.symbol}}</span>
        <ins>{{price}}</ins>
        <span v-if="isSymbolBehindPrice">{{detailData.symbol}}</span>
        <span v-if="detailData.iso_code === 'JPY'" style="font-size:18px; color:#333">(税抜)</span>
        <del v-if="!isSymbolBehindPrice" :style="{'letter-spacing': detailData.symbol === '฿' ? '2px' : ''}">{{detailData.symbol}}</del>
        <del>{{comparePrice}}</del>
        <del v-if="isSymbolBehindPrice">{{detailData.symbol}}</del>
      </div>
    </div>
    <!--  商品描述  -->
      <h1 v-html="detailData.title"></h1>
    <!-- 商品特点 -->
    <div class="feature" v-if="config.show_feature">
      <span v-bind:key="item" v-for="item in ['續航強', '性價比高', '外形時尚']">{{item}}</span>
    </div>
    <!-- 商品服务 -->
    <div class="service" v-if="config.show_service">
        <span v-bind:key="item" v-for="item in filteredItems">
          <img src="../../assets/img/detail/ok.svg" alt="">
          {{item}}
        </span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      detailData: {
        type: Object,
        default: {}
      },
      lang: {
        type: Object,
        default: {}
      },
      config: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        cl: sessionStorage.cl,
        price: this.detailData.price && Number(this.detailData.price).toFixed(0),
        comparePrice: this.detailData.compare_price && Number(this.detailData.compare_price).toFixed(0),
        // 符号在价格后面的国家，对应detailData.iso_code
        symbolBehindPriceCode: [
          'ALL', // 阿尔巴尼亚
          'BGN', // 保加利亚
          'CZK', // 捷克
          'DKK', // 丹麦
          'HRK', // 克罗地亚
          'HUF', // 匈牙利
          'ISK', // 冰岛
          'MDL', // 摩尔多瓦
          'NOK', // 挪威
          'PLN', // 波兰
          'RON', // 罗马尼亚
          'RSD', // 塞尔维亚
          'SEK', // 瑞典
          'UAH'  // 乌克兰
        ]
      }
    },
    computed: {
      filteredItems() {
        const allowedProperties = ['free_shipping', 'cash_on_delivery', 'seven_day'];

        if (window.location.hostname === 'www.cheapct.top') {
          // 移除 'cash_on_delivery' 属性
          allowedProperties.splice(1, 1);
        }
        return allowedProperties.map(property => this.lang[property]);
      },
      // 是否货币符合展示在价格后面
      isSymbolBehindPrice() {
        return this.symbolBehindPriceCode.includes(this.detailData.iso_code);
      }
    }
  }
</script>

<style scoped>
  .brief .sales {
    width: 100%;
    padding: 10px;
    margin: 0 auto;
    color: #333;
    border-bottom: 1px solid #eee;
  }

  .brief .sales .price {
    font-size: 1.5rem;
    color: #e31a07;
    font-weight: bolder;
  }

  .brief .sales .price ins {
    font-size: 1.625rem;
  }

  .brief .sales .price del {
    color: #969090e0;
    font-size: 1.25rem;
  }

  .brief h1 {
    /*text-overflow: -o-ellipsis-lastline;*/
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    padding: 5px;
    color: #333;
    font-size: 1rem;
    line-height: 26px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
  }

  .feature {
    padding: 4px 8px;
    border-bottom: 1px solid #eee;
    color: #e31a07;
    font-size: .875rem;
    font-weight: bold;
  }

  .feature span {
    margin-right: 12px;
    white-space: nowrap;
  }

  .service {
    padding: 8px;
    border-bottom: 1px solid #eee;
  }

  .service span {
    font-size: 0.875rem;
    margin-right: 10px;
  }

  .service img {
    width: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/detail/brief.vue